import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["d"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: _ctx.pause ? 'M 7 5 L 7 19 L 10 19 L 10 5 Z M 14 5 L 14 19 L 17 19 L 17 5 Z' : 'M 8 5.14 L 8 19.14 L 13.5 15.64 L 13.5 8.64 Z M 13.5 8.64 L 13.5 15.64 L 19 12.14 L 19 12.14 Z',
      fill: "white",
      style: {"transition":"d 300ms ease"}
    }, null, 8, _hoisted_2)
  ]))
}